import React, { useState } from 'react'
import { Button, TextField, Autocomplete } from '@mui/material'
import { useGeneralData } from '../hooks/useGeneralData'
import styles from './ManageDatasetsPermissions.module.scss'

export default function ManageDatasetsPermissions(){
    const [datasetsToAcess, setDatasetsToAcess] = useState([])
    const [usersToAccess, setUsersToAccess] = useState([])
    const {datasets, users, blockDatasets,AccessDatasets } = useGeneralData()

    const handleBlockDatasets = () => {
        // blockDatasets(datasetsToAcess, usersToAccess)
        AccessDatasets(datasetsToAcess, usersToAccess)
        setDatasetsToAcess([])
        setUsersToAccess([])
    }

    const getOptionLabel = (option) => option.name
    const renderInput = (params, label) => (<TextField {...params} label={`Choose ${label} to access`} variant="outlined" />)
    const updateDatasetsToAcess = (e, value) => setDatasetsToAcess(value)
    const updateUsersToAccess = (e, value) => setUsersToAccess(value)

    return (
        <>
            <div className={styles['autocompletes-container']}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={users}
                    getOptionLabel={getOptionLabel}
                    style={{ width: 300 }}
                    renderInput={(params) => renderInput(params, 'users')}
                    value={usersToAccess}
                    onChange={updateUsersToAccess}
                    loading={!!users}
                />
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={datasets}
                    getOptionLabel={getOptionLabel}
                    style={{ width: 300 }}
                    renderInput={(params) => renderInput(params, 'datasets')}
                    value={datasetsToAcess}
                    onChange={updateDatasetsToAcess}
                    loading={!!datasets}
                />
            </div>
            <div className={styles['submit']}><Button variant="contained" color="primary" onClick={handleBlockDatasets}> Submit </Button></div>
        </>
    )
}